import axios from 'axios'

let baseUrl = (window.location.origin ? window.location.origin : window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''))
if (baseUrl === 'http://localhost:8080') baseUrl = 'http://site.choc-ickx.lunar'

// export const getAllTranslations = ({ lang }) => {
//     const path = `${baseUrl}/assets/data/translations/${lang}.json`

//     const headers = {
//         'Accept': 'application/json'
//     }

//     return axios({
//         method: 'get',
//         url: path,
//         headers: headers
//     }).then(result => {
//         if (result.status >= 200 && result.status < 300) return result.data
//         else return result.then(Promise.reject(result.message))
//     })
// }

export const globals = ({ lang }) => {
    const path = `${baseUrl}/api/globals?lang=${lang}`

    const headers = {
        'Accept': 'application/json'
    }

    return axios({
        method: 'get',
        url: path,
        headers: headers
    }).then(result => {
        if (result.status >= 200 && result.status < 300) return result.data
        else return result.then(Promise.reject(result.message))
    })
}

export const seo = ({ slug }) => {
    let path = `${baseUrl}/actions/seomatic/meta-container/all-meta-containers/?uri=${slug}/&asArray=true`

    const headers = {
        'Accept': 'application/json'
    }
    return axios({
        method: 'get',
        url: path,
        headers: headers
    }).then(result => {
        if (result.status >= 200 && result.status < 300) {
            return result
        } else {
            return result.then(Promise.reject(result.message))
        }
    })
}

export const page = ({ slug, lang }) => {
    const path = `${baseUrl}/api/pages/${slug}?lang=${lang}`

    const headers = {
        'Accept': 'application/json'
    }

    return axios({
        method: 'get',
        url: path,
        headers: headers
    }).then(result => {
        if (result.status >= 200 && result.status < 300) return result.data
        else return result.then(Promise.reject(result.message))
    })
}

export const jobs = ({ slug, lang }) => {
    const path = `${baseUrl}/api/jobs?lang=${lang}`

    const headers = {
        'Accept': 'application/json'
    }

    return axios({
        method: 'get',
        url: path,
        headers: headers
    }).then(result => {
        if (result.status >= 200 && result.status < 300) return result.data
        else return result.then(Promise.reject(result.message))
    })
}

export const single = ({ slug, lang }) => {
    const path = `${baseUrl}/api/singles/${slug}?lang=${lang}`

    const headers = {
        'Accept': 'application/json'
    }

    return axios({
        method: 'get',
        url: path,
        headers: headers
    }).then(result => {
        if (result.status >= 200 && result.status < 300) return result.data
        else return result.then(Promise.reject(result.message))
    })
}

export const channel = ({ handle, slug, lang }) => {
    const path = `${baseUrl}/api/channel/${handle}/${slug}?lang=${lang}`

    const headers = {
        'Accept': 'application/json'
    }

    return axios({
        method: 'get',
        url: path,
        headers: headers
    }).then(result => {
        if (result.status >= 200 && result.status < 300) return result.data
        else return result.then(Promise.reject(result.message))
    })
}

// Export
export default {
    globals,
    seo,
    single,
    page,
    jobs,
    channel
    // getAllTranslations
}
